import { observable } from 'mobx'
/*
  isXXL 是不是大于1600px
	showDetailNav 是否显示详细导航
	showNarrowNav 是否显示缩小按钮
  showLogoutTip 是否显示登录失效弹窗
  TopTips 当前用户的提醒列表是否置顶显示
  MusicTips 当前用户的提醒声音是否开启
  isShowTips 是否显示全局提示（文字用变量存起来）
*/
class Store {
  @observable needUpdateNav = false
  @observable isShowTips = false
  @observable tipsContent = ''
  @observable isXXL = false
  @observable isFullScreen = false
  @observable showLoading = false
  @observable showLogoutTip = false
  @observable showNavDialog = false
  @observable showDetailNav = true
  @observable showNarrowNav = false
  @observable TopTips = false
  @observable MusicTips = false

  constructor() {
    if (window.innerWidth > 1600) {
      this.isXXL = true
    }
  }
}
const GlobalControlStore = new Store()

export default GlobalControlStore



// WEBPACK FOOTER //
// ./src/store/GlobalControlStore.js